import { useCallback, useState } from 'react';

export function useLoading() {
  const [isLoading, setIsLoading] = useState(false);

  const startTransaction = useCallback(async <T>(callback: () => Promise<T>) => {
    try {
      setIsLoading(true);
      return await callback();
    } finally {
      setIsLoading(false);
    }
  }, []);

  return [isLoading, startTransaction] as const;
}
